import { combineReducers } from "@reduxjs/toolkit";

import globalSlice from "./global.slice";
import CartModule from "../pages/cart/services/slice";
import StrainSlice from "../pages/strains/services/slice";
import BatchesSlice from "../pages/batches/services/slices";
import LoginSlice from "../pages/login/services/login.slice";
import SubscriptionSlice from "../pages/subscription/services/slice";
import QRCodeSlice from "../pages/qr-code-purchasing/services/slices";
import MyProfileModuleSlice from "../pages/my-profile/services/slices";
import AccountSlice from "../pages/accounts-management/services/slice";
import AnnouncementModule from "../pages/announcements/services/slices";
import RewardsModule from "../pages/rewards-management/services/slices";
import verifyEmailSlice from "../pages/login/services/verifyEmail.slice";
import APIConnectionSlice from "../pages/api-connections/services/slice";
import CompanyProfileModule from "../pages/company-profile/services/slices";
import resetPasswordSlice from "../pages/login/services/resetPasswordSlice";
import forgetPasswordSlice from "../pages/login/services/forgetPassword.slice";
import EmployeeManagementModule from "../pages/employees-management/services/slices";
import consumersManagementSlice from "../pages/consumers-management/services/slices";
import AnalyticsSlice from "../pages/analytics/services/slices";
import engagementReducer from "../pages/analytics/tabs/engagement/services/slice";
import sentimentReducer from "../pages/analytics/tabs/sentiment/services/slice";
import consumersReducer from "../pages/analytics/tabs/consumers/services/slice";

const rootReducer = combineReducers({
  cart: CartModule,
  login: LoginSlice,
  strain: StrainSlice,
  qrCode: QRCodeSlice,
  batches: BatchesSlice,
  rewards: RewardsModule,
  myAccount: AccountSlice,
  analytics: AnalyticsSlice,
  analyticsEngagement: engagementReducer,
  analyticsSentiment: sentimentReducer,
  analyticsConsumers: consumersReducer,
  globalcontent: globalSlice,
  verifyEmail: verifyEmailSlice,
  subscription: SubscriptionSlice,
  myProfile: MyProfileModuleSlice,
  announcement: AnnouncementModule,
  apiConnection: APIConnectionSlice,
  resetPassword: resetPasswordSlice,
  forgetPassword: forgetPasswordSlice,
  companyProfile: CompanyProfileModule,
  employeeManagement: EmployeeManagementModule,
  consumersManagement: consumersManagementSlice,
});

export default rootReducer;
